// removed by extract-text-webpack-plugin
module.exports = {"responsibleDisclosurePage":"src-templates-responsibleDisclosurePage----responsibleDisclosurePage-module---responsibleDisclosurePage---17CD8","left":"src-templates-responsibleDisclosurePage----responsibleDisclosurePage-module---left---2z1NP","right":"src-templates-responsibleDisclosurePage----responsibleDisclosurePage-module---right---39rd3"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/responsibleDisclosurePage/responsibleDisclosurePage.module.scss
// module id = 297
// module chunks = 69949351783210 95715928098905